export interface BrandMarkProps {
  size?: number
  animate?: boolean
}

/**
 * Two interlinked rings — the official mark, geometry and gradient exactly as
 * brand/mark/loop-mark-gradient.svg (viewBox 120×100, r 27, stroke 13).
 *
 * The <defs> block is rendered unconditionally: putting the gradient inside
 * the animated branch means it disappears on the first state change and every
 * stroke silently renders black. A ring's circumference (2π·27 ≈ 170) is what
 * nocturne's `ringDraw` keyframe dashes from.
 */
export function BrandMark({ size = 44, animate = false }: BrandMarkProps) {
  const ring = (cx: number, delay: number) => (
    <circle
      key={cx}
      cx={cx}
      cy={50}
      r={27}
      fill="none"
      stroke="url(#loop-mark-gradient)"
      strokeWidth={13}
      strokeDasharray={animate ? 170 : undefined}
      style={animate ? { animation: `ringDraw 900ms ease-out ${delay}ms both` } : undefined}
    />
  )

  return (
    <svg width={size} height={size} viewBox="0 0 120 100" role="img" aria-label="Loop CMS">
      <defs>
        <linearGradient id="loop-mark-gradient" gradientUnits="userSpaceOnUse" x1="15" y1="77" x2="105" y2="23">
          <stop offset="0" stopColor="#7CB8F2" />
          <stop offset="0.45" stopColor="#7B53F0" />
          <stop offset="1" stopColor="#33206E" />
        </linearGradient>
      </defs>
      {ring(42, 0)}
      {ring(78, 120)}
    </svg>
  )
}
